import script from "./MetricsView.vue?vue&type=script&setup=true&lang=js"
export * from "./MetricsView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__